import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldOff, ArrowLeft } from 'lucide-react';

const Forbidden: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <div className="max-w-md w-full text-center">
        <div className="mx-auto mb-6 w-16 h-16 rounded-full bg-red-100 flex items-center justify-center">
          <ShieldOff className="w-8 h-8 text-red-500" />
        </div>
        <h1 className="text-2xl font-semibold text-gray-900 mb-2">Access Restricted</h1>
        <p className="text-gray-500 mb-2">
          You don't have permission to view this page.
        </p>
        <p className="text-sm text-gray-400 mb-8">
          This area requires <strong>administrator</strong> privileges. Contact your administrator
          if you believe you should have access.
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-iflow-600 text-white text-sm font-medium hover:bg-iflow-700 transition-colors"
        >
          <ArrowLeft className="w-4 h-4" />
          Back to Dashboard
        </Link>
      </div>
    </div>
  );
};

export default Forbidden;
